module.exports = __webpack_public_path__ + "static/media/homepage_atf_3_en.b4576218.png";